window.addEventListener("load", function () {
  document.body.style.opacity = "1";
});

// Nav menu
const clickDiv = document.querySelector('.menu_icon');
const slideDiv = document.querySelector('.main-nav');
const childMenu = document.querySelector('.main-nav');
const over = document.querySelector('.drop_over');

clickDiv.addEventListener('click', () => {
  const isOpen = slideDiv.classList.toggle('is-open');

  if (isOpen) {
    slideDiv.style.maxHeight = slideDiv.scrollHeight + 'px';

    // delay child menu class
    setTimeout(() => {
      childMenu.classList.add('active');
    }, 300); // 300ms delay (animation match)
    over.classList.add('active');

  } else {
    slideDiv.style.maxHeight = null;
     setTimeout(() => {
    childMenu.classList.remove('active');
     }, 300); // 300ms delay (animation match)
      over.classList.remove('active');
  }
});


over.addEventListener('click', () => {
    const isOpen = slideDiv.classList.remove('is-open');
    slideDiv.style.maxHeight = null;
     setTimeout(() => {
    childMenu.classList.remove('active');
     }, 300); // 300ms delay (animation match)
      over.classList.remove('active');
});


/*
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".product-card-wrapper").forEach(function(card){

    const mainImage = card.querySelector(".product-main-image");
    const swatches = card.querySelectorAll(".color-swatch");

    if(!mainImage || !swatches.length) return;

    swatches.forEach(function(swatch){

      swatch.addEventListener("click", function(e){
        e.preventDefault();

        const newSrc = this.getAttribute("data-src");
        const newSrcset = this.getAttribute("data-srcset");

        alert(newSrc);

        if(newSrc){
          mainImage.src = newSrc;
        }

        if(newSrcset){
          mainImage.srcset = newSrcset;
        }

        // optional active class
        swatches.forEach(s => s.classList.remove("active"));
        this.classList.add("active");

      });

    });

  });

});
*/



const openBtn = document.querySelector('#search_open');
const popup = document.querySelector('#search_popup');
const searchOver = document.querySelector('.search-over');

openBtn.addEventListener('click', () => {
  popup.classList.add('active');
});

searchOver.addEventListener('click', () => {
  popup.classList.remove('active');
});
